export default __webpack_public_path__ + "assets/images/single_belt_cooler_55ffe36219aacc07fc34ccdd20e9f8be.jpg";